import { render, staticRenderFns } from "./CartDetail.vue?vue&type=template&id=239d0bf1&scoped=true"
import script from "./CartDetail.vue?vue&type=script&lang=js"
export * from "./CartDetail.vue?vue&type=script&lang=js"
import style0 from "./CartDetail.vue?vue&type=style&index=0&id=239d0bf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d0bf1",
  null
  
)

export default component.exports